/** Shopify CDN: Minification failed

Line 12:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 13:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 17:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 18:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 19:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('collapse-text')) {
    customElements.define('collapse-text', class CollapseText extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init(){
        const btn = this.querySelector('.readmore');
        const short_content = this.querySelector('.short__text');
        const full_content = this.querySelector('.full_text');
        btn.addEventListener("click", function(){
          if(short_content){
            short_content.style.display = 'none';
          }
          if(full_content){
            full_content.style.display = 'block';
          }
          this.style.display = 'none';
        })
      }
    });
  }